module.exports = __webpack_public_path__ + "static/media/screenshot_1.078cc673.avif";